import Header from "../components/Header";
import { useState, useEffect, useRef } from "react";
import "./scss/adminPay.scss";
import NavigateBeforeOutlinedIcon from "@mui/icons-material/NavigateBeforeOutlined";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import axiosInstance from "../api/axiosInstance";
import { useParams } from "react-router-dom";
import { useCommonUtil } from "../util/useCommonUtil";
import AlertModal from "../components/AlertModal";
import { format } from "date-fns";
import { rootReducer } from "../store/store";
import { useSelector } from "react-redux";
import { usePrintUtils } from "../util/usePrintUtils";
import ReceiptPrintService from "../api/ReceiptPrintService";
import { ApprovalResult } from "../types/ApprovalResult";
import { useHistory } from "react-router-dom";
import {
  AlertType,
  alertType
} from "../types/CommonType";

type AuthState = ReturnType<typeof rootReducer>;
const getFormattedDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

declare global {
  interface Window {
    cancelChargeResult: any;
    approvalResultString: any; // 키오스크 결제 승인 결과 코드 (출고 시점에 결제한 결과)
    getCustomerKeepInfo: any;
    getEmployeeSubmissionInfo: any;
  }
}

const alertInfoType = {
  alertShow: false,
  title: "",
  content: ""
};

const AdminPay: React.FC = () => {
  window.cancelChargeResult = cancelChargeResult;
  window.getCustomerKeepInfo = getCustomerKeepInfo;
  window.getEmployeeSubmissionInfo = getEmployeeSubmissionInfo;

  const history = useHistory();
  const kioskInfo = useSelector((state: AuthState) => state.store.kioskInfo);
  const { formatNumber } = useCommonUtil();
  const [selectedDate, setSelectedDate] = useState<string>(
    getFormattedDate(new Date())
  );
  const [companyCallInfo, setCompanyCallInfo] = useState<string>("");
  const [customerCaution, setCustomerCaution] = useState<string>("");
  const [returnAddrInfo, setReturnAddrInfo] = useState<string>("");
  const [customerAdress, setCustomerAdress] = useState<string>("");
  const [alertInfoAdmin, setAlertInfoAdmin] = useState(alertInfoType);
  const loginUserId = useSelector((state: AuthState) => state.store.loginUserId);
  const [alertInfo, setAlertInfo] = useState<AlertType>(alertType);

  const cancelApprovalReservationId = useRef<string>("");

  const [companyInfo, setCompanyInfo] = useState<any>({});
  const [reservations, setReservations] = useState<any[]>([]);
  const { userId, companyId } = useParams<{
    userId: string;
    companyId: string;
  }>();

  const [isScrolledToBottom, setIsScrolledToBottom] = useState<boolean>(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // 고객 보관용 / 직원 제출용 인수증 출력 데이터
  const { convertReceiptListToObject } = usePrintUtils();
  const printInfo = useRef<any>({});

  const handleScroll = () => {
    const container = scrollContainerRef.current;
    if (container) {
      const maxScroll = container.scrollHeight - container.clientHeight;
      console.log("maxScroll", maxScroll);
      if (container.scrollTop >= maxScroll) {
        setIsScrolledToBottom(true);
      }
    }
  };

  function cancelChargeResult (result: string) {
    if(result !== "success") {
      setAlertInfoAdmin({
        alertShow: true,
        title: "결제 취소 실패",
        content: "결제 취소가 실패했습니다. 직원에게 문의 바랍니다."
      });

      return false;
    }

    const cancelApprovalResult = (window as any).approvalResult;
    afterCancelCharge(cancelApprovalResult);
  }

  const afterCancelCharge = (cancelApprovalResult: ApprovalResult) => {
    try{
      console.log("cancelApprovalResult", cancelApprovalResult);

      let approvalMemo = "키오스크 결제 취소 : " + cancelApprovalResult.RS14 + "(승인번호 : " + cancelApprovalResult.RS09 + ")";
      axiosInstance()
        .post(`/kiosk/saveApprovalInfo.do`, {
          kioskUserId: kioskInfo?.data.kioskUserId,
          reservationId: cancelApprovalReservationId.current,
          inoutType: "OUT",
          companyId: companyId,
          approvalValue: cancelApprovalResult.RQ07,
          approvalMemo: approvalMemo,
          approvalCode: cancelApprovalResult.RS09,
          approvalDate: cancelApprovalResult.RS07,
          purchaseCorp: cancelApprovalResult.RS14,
          approvalResult: JSON.stringify(cancelApprovalResult),
        })
        .then((res) => {
          setAlertInfoAdmin({
            alertShow: true,
            title: "결제 취소 완료",
            content: "해당 결제 건에 대하여 취소 처리되었습니다."
          });
        })
        .catch((error) => {
          console.log(error);
          setAlertInfoAdmin({
            alertShow: true,
            title: "결제 취소 정보 저장 실패",
            content: "결제 취소 정보 저장 중 오류가 발생했습니다. 직원에게 문의 바랍니다."
          });
        })
        .finally(() => {
          cancelApprovalReservationId.current = "";
          getPayList();
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 오류",
          content: "오류가 발생했습니다.</br>다시 시도해주세요.",
          callback: () => history.push("/main")
      });
    }
  }

  const getPayList = async () => {
    try{
      await axiosInstance()
        .post(`/kiosk/admin/approvals.do`, {
          userId: kioskInfo?.data.kioskUserId || "",
          companyId: companyId,
          searchDt: selectedDate.replaceAll("-", "")
        })
        .then((res) => {
          setReservations(res.data.data.reservations);
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 오류",
          content: "오류가 발생했습니다.</br>다시 시도해주세요.",
          callback: () => history.push("/main")
      });
    }
  };

  const getBillInfo = async () => {
    try{
      await axiosInstance()
        .post(`/kiosk/GetBillInfo.do`, {
          companyId: companyId
        })
        .then((res) => {
          if (res.data.length > 0) {
            res.data.map((e: any) => {
              if (e.termsType === "COMPANY_CALL_INFO") {
                setCompanyCallInfo(e.contents);
                setCustomerAdress(e.address);
              }
              if (e.termsType === "CUSTOMER_CAUTION") {
                setCustomerCaution(e.contents);
              }
              if (e.termsType === "RETURN_ADDR_INFO") {
                setReturnAddrInfo(e.contents);
              }
            });
          }
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 오류",
          content: "오류가 발생했습니다.</br>다시 시도해주세요.",
          callback: () => history.push("/main")
      });
    }
  };

  const getCompanyInfo = async () => {
    try{
      await axiosInstance()
        .get(`/kiosk/admin/companies.do?companyId=${companyId}&userId=${loginUserId || ""}`)
        .then((res) => {
          setCompanyInfo(res.data.data);
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 오류",
          content: "오류가 발생했습니다.</br>다시 시도해주세요.",
          callback: () => history.push("/main")
      });
    }
  };

  const payCancel = (item: any) => {
    console.log("payCancel");
    const kioskOperation: HTMLInputElement | null = document.getElementById(
      "kioskOperation"
    ) as HTMLInputElement | null;
    if (kioskOperation) {
      kioskOperation.value = "adminCancelCharge";
    }

    const ApprovalStatus: HTMLInputElement | null = document.getElementById(
      "ApprovalStatus"
    ) as HTMLInputElement | null;
    if (ApprovalStatus) {
      ApprovalStatus.value = "process";
    }

    // 전역 변수 저장 (C#이 ExecuteScriptAsync로 가져올 수 있도록)
    window.approvalResultString = item.approvalResult;

    cancelApprovalReservationId.current = item.reservationId;
  };

  const rePrintExchangeTicket = async (item: any) => {
    console.log("rePrint");
    console.log(item);

    const fieldsMapping: { [key: string]: string } = {
      customerParkingLocationUse: companyInfo.customerParkingLocationUse || "",
      employeeContentUse: companyInfo.employeeContentUse || "",
      parkingStr: item.takeoverLocation || "",
      parkingDetail: item.exportLocationDetail || "",
      carNumber: item.carNumber || "",
    };

    Object.entries(fieldsMapping).forEach(([id, value]) => {
      const inputField = document.getElementById(id) as HTMLInputElement | null;
      if (inputField) {
        inputField.value = value;
      }
    });
    
    // 여기 아래에서 인수증 데이터 조회 API 호출
    ReceiptPrintService.getPrintInfo(item.companyId, item.reservationId).then((res) => {
      const result = res.data.list;
      console.log("receipt print info", result);
      printInfo.current = convertReceiptListToObject(result);

      const kioskOperation: HTMLInputElement | null = document.getElementById(
        "kioskOperation"
      ) as HTMLInputElement | null;
      if (kioskOperation) {
        kioskOperation.value = "adminReprintTickets";
      }
    });

    window.approvalResultString = item.approvalResult;
  };

  const rePrintApprovalReceipt = (item: any) => {
    console.log("receipt");
    const kioskOperation: HTMLInputElement | null = document.getElementById(
      "kioskOperation"
    ) as HTMLInputElement | null;
    if (kioskOperation) {
      kioskOperation.value = "adminReprintReceipt";
    }
    window.approvalResultString = item.approvalResult;
  };

  const rePrintCancelReceipt = (item: any) => {
    console.log("cancelReceipt");
    const kioskOperation: HTMLInputElement | null = document.getElementById(
      "kioskOperation"
    ) as HTMLInputElement | null;
    if (kioskOperation) {
      kioskOperation.value = "printCancelRentInfo";
    }
    window.approvalResultString = item.approvalResult;
  };
  
  // 고객 보관용 인수증 데이터 (C# 에서 호출)
  function getCustomerKeepInfo() {
    const currentInfo = printInfo.current;

    console.log("getCustomerKeepInfo", currentInfo.customerKeepInfo);
    return currentInfo.customerKeepInfo;
  }

  // 직원 제출용 인수증 데이터 (C# 에서 호출)
  function getEmployeeSubmissionInfo() {
    const currentInfo = printInfo.current;

    console.log("getEmployeeSubmissionInfo", currentInfo.employeeSubmissionInfo);
    return currentInfo.employeeSubmissionInfo;
  }

  const handleTouchMove = (e: any) => {
    // 특정 div 영역 내에서는 터치 이벤트의 기본 동작을 막지 않음
    e.stopPropagation(); // 이벤트 전파 중단
  };

  useEffect(() => {
    getPayList();
  }, [selectedDate]);

  useEffect(() => {
    getPayList();
    getBillInfo();
    getCompanyInfo();

    const payTableWrapper = document.getElementById('pay-table-wrapper');
    if (payTableWrapper) {
      payTableWrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
      return () => {
        payTableWrapper.removeEventListener('touchmove', handleTouchMove);
      };
    }

    // 결제 응답을 받기 위해 윈도우 리스너에 등록
    const handleCustomPropertyChange = () => {
      const approvalResult = (window as any).approvalResult;
      // C#에서 해당 이벤트 리스너로 응답을 준다.
      window.addEventListener("approvalResult", approvalResult);
    };

    window.addEventListener("customPropertyChange", handleCustomPropertyChange);

    return () => {
      window.removeEventListener(
        "customPropertyChange",
        handleCustomPropertyChange
      );
    }
  }, []);

  const handleDateChange = (amount: number) => {
    const currentDate = new Date(selectedDate);
    currentDate.setDate(currentDate.getDate() + amount);
    setSelectedDate(getFormattedDate(currentDate));
  };

  const btnStyles: React.CSSProperties = {
    color: "white",
    fontSize: "25px",
    padding: "10px",
    background: "red",
    border: "none",
    whiteSpace: "nowrap",
    fontWeight: "700",
    marginBottom: "5px"
  };
  //  결제 영수증 rePrintRentInfo
  //  확인증 printExchangeTicket
  return (
    <>
      <Header></Header>
      <div className="admin-pay-wrap">
        <div className="admin-title-wrap">결제 처리내역</div>
        <div className="date-wrap">
          <div className="date-container">
            <div className="prev" onClick={() => handleDateChange(-1)}>
              <SvgIcon
                component={NavigateBeforeOutlinedIcon}
                style={{ fontSize: "3em" }}
              ></SvgIcon>
            </div>
            <span className="date">{selectedDate}</span>
            <div className="next" onClick={() => handleDateChange(1)}>
              <SvgIcon
                component={NavigateNextOutlinedIcon}
                style={{ fontSize: "3em" }}
              ></SvgIcon>
            </div>
          </div>
        </div>

        <div 
          id="pay-table-wrapper"
          className="pay-table-wrapper"
          ref={scrollContainerRef}
          onScroll={handleScroll}
        >
          <table className="pay-table">
            <thead>
              <tr>
                <th className="pay-th">출고시간</th>
                <th className="pay-th">예약자</th>
                <th className="pay-th">모델명</th>
                <th className="pay-th">차량번호</th>
                <th className="pay-th">운전자</th>
                <th className="pay-th">결제금액</th>
                <th className="pay-th"></th>
              </tr>
            </thead>
            <tbody>
              {reservations &&
                reservations.map((e, idx) => (
                  <tr key={idx} className="pay-tr">
                    <td className="pay-td">
                      {new Date(e.takeoverDtm).toLocaleTimeString("ko-KR", {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: false
                      })}
                    </td>
                    <td className="pay-td">{e.req1stUserName}</td>
                    <td className="pay-td">{e.modelName}</td>
                    <td className="pay-td">{e.carNumber}</td>
                    <td className="pay-td">
                      {e.driver1stName} <br/>
                      ({e.driver1stTel})
                    </td>
                    <td className={`pay-td ${e.approvalType !== "IN" ? "approval-out" : ""}`}>
                      {formatNumber(e.approvalValue || 0)}{" "}
                    </td>
                    <td className="pay-td">
                      <button
                        onClick={() => {
                          rePrintExchangeTicket(e);
                        }}
                        style={btnStyles}
                      >
                        확인증 재출력
                      </button>
                      <button
                        onClick={() => {
                          rePrintApprovalReceipt(e);
                        }}
                        disabled={
                          e.approvalValue === 0 || e.approvalValue === null
                        }
                        style={btnStyles}
                      >
                        영수증 재출력
                      </button>
                      { e.approvalType === "IN" &&
                        <button
                          onClick={() => {
                            payCancel(e);
                          }}
                          style={btnStyles}
                        >
                          결제취소
                        </button>
                      }
                      { e.approvalType && e.approvalType !== "IN" &&
                        <button
                          onClick={() => {
                            rePrintCancelReceipt(e);
                          }}
                          style={btnStyles}
                        >
                          취소 영수증 재출력
                        </button>
                      }
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      {alertInfoAdmin.alertShow && (
        <AlertModal
          onClose={() => {
            setAlertInfoAdmin((prev: any) => ({
              ...prev,
              alertShow: false
            }));
          }}
          title={alertInfoAdmin.title}
          content={alertInfoAdmin.content}
        ></AlertModal>
      )}
      {alertInfo.show && (
        <AlertModal
          onClose={() => {
            if (alertInfo.callback) {
              alertInfo.callback(); // 콜백 함수 호출
            } else setAlertInfo((prev) => ({ ...prev, show: false }));
          }}
          title={alertInfo.title}
          content={alertInfo.content}
        ></AlertModal>
      )}
      <input type="hidden" name="kioskOperation" id="kioskOperation" value="" />
      <input type="hidden" name="ApprovalStatus" id="ApprovalStatus" value="" />
      {/* 확인증 input */}
      <input type="hidden" id="customerParkingLocationUse" value="" />
      <input type="hidden" id="employeeContentUse" value="" />
      <input type="hidden" id="parkingStr" value="" />
      <input type="hidden" id="parkingDetail" value="" />
      <input type="hidden" id="carNumber" value="" />
      <input type="hidden" id="adminLicenseCheck" value="" />

      {/* 영수증 출력 시 사용되는 업체 정보 */}
      <input
        type="hidden"
        name="ApprovalCompanyName"
        id="ApprovalCompanyName"
        value={companyInfo.receiptCompanyName}
      ></input>
      <input
        type="hidden"
        name="ApprovalCompanyCEO"
        id="ApprovalCompanyCEO"
        value={companyInfo.ceoName}
      ></input>
      <input
        type="hidden"
        name="ApprovalCompanyTel"
        id="ApprovalCompanyTel"
        value={companyCallInfo}
      ></input>
      <input
        type="hidden"
        name="ApprovalCompanyRegNum"
        id="ApprovalCompanyRegNum"
        value={companyInfo.receiptBusinessNum}
      ></input>
      <input
        type="hidden"
        name="ApprovalCompanyAddr"
        id="ApprovalCompanyAddr"
        value={customerAdress}
      ></input>
      {/** END */}
    </>
  );
};

export default AdminPay;
